/* QA-012 — visor inline de respaldos (imagen/PDF) sobre la página actual: sin pestañas nuevas, sin perder formulario ni scroll.
 * Cierre con X, Escape o clic en el fondo (Radix Dialog). Fallback "Abrir documento" para formatos no renderizables. */
import { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '@/shared/ui';

export type LightboxDoc = { public_id: string; display_name?: string | null; original_filename: string; detected_mime: string; content_path: string };
const RENDERABLE_IMG = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

export function docLabel(d: { display_name?: string | null; original_filename: string }): string {
  return d.display_name || d.original_filename;
}

export function DocumentLightbox({ doc, onClose }: { doc: LightboxDoc; onClose: () => void }) {
  const isImg = RENDERABLE_IMG.includes(doc.detected_mime);
  const isPdf = doc.detected_mime === 'application/pdf';
  const [zoom, setZoom] = useState(false);
  return (
    <Dialog.Root open onOpenChange={(o) => !o && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.72)', zIndex: 70 }} />
        <Dialog.Content aria-describedby={undefined} style={{ position: 'fixed', inset: 0, zIndex: 71, display: 'flex', flexDirection: 'column', padding: 'max(8px, env(safe-area-inset-top)) 8px 8px' }} data-testid="doc-lightbox">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <Dialog.Title style={{ margin: 0, fontSize: 'var(--fs-sm)', color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{docLabel(doc)}</Dialog.Title>
            <Dialog.Close asChild><Button type="button" size="sm" variant="secondary" aria-label="Cerrar visor" style={{ minWidth: 44 }}>✕ Cerrar</Button></Dialog.Close>
          </div>
          <div style={{ flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'auto' }} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            {isImg && <img src={doc.content_path} alt={docLabel(doc)} onClick={() => setZoom(!zoom)} style={{ maxWidth: zoom ? 'none' : '100%', maxHeight: zoom ? 'none' : '100%', objectFit: 'contain', cursor: zoom ? 'zoom-out' : 'zoom-in', borderRadius: 6, background: '#fff' }} />}
            {isPdf && <object data={doc.content_path} type="application/pdf" style={{ width: '100%', height: '100%', border: 0, borderRadius: 6, background: '#fff' }} aria-label={docLabel(doc)}><FallbackOpen doc={doc} /></object>}
            {!isImg && !isPdf && <FallbackOpen doc={doc} />}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

function FallbackOpen({ doc }: { doc: LightboxDoc }) {
  return (
    <div style={{ background: 'var(--sgr-bg)', borderRadius: 8, padding: 'var(--sp-4)', textAlign: 'center' }}>
      <p style={{ fontSize: 'var(--fs-sm)', marginTop: 0 }}>Este formato no se puede previsualizar aquí.</p>
      <a href={doc.content_path} target="_blank" rel="noreferrer"><Button type="button" size="sm">Abrir documento</Button></a>
    </div>
  );
}
